import { faAdd, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { GoogleMap, LoadScript, Polygon } from "@react-google-maps/api";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Select from "react-select";
import LoadingIcon from "../../../components/loading/LoadingIcon";
import { setIsUpdating } from "../../../redux/app/regions/region-slice";
import { toast } from "react-toastify";

const EditRegiontow = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { allVehicles, categories } = useSelector((state) => state.vehicle);
  const { regionData, isUpdating, regionMetaData } = useSelector(
    (state) => state.region
  );
  const [foundedLatLng, setfoundedLatLng] = useState();
  const navigate = useNavigate();
  const { id } = useParams();

  const [center, setCenter] = useState({ lat: 0, lng: 0 });
  const [pathInitial, setPathInitial] = useState([]);
  const [pathCheck, setpathCheck] = useState([]);
  const [regionEdit, setRegionEdit] = useState({
    name: "",
    distance_per_hour: "",
  });
  const [regionMetaDataEdit, setRegionMetaDataEdit] = useState({});

  // Fetch the boundary polygon for a city
  async function getCityBoundary(cityName) {
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/search`,
        {
          params: {
            q: cityName,
            format: "jsonv2",
            polygon_geojson: 1,
          },
        }
      );

      // Return the polygon from the response
      const cityData = response.data[0];
      console.log("cityData", cityData);

      if (cityData && cityData.geojson) {
        return cityData.geojson;
      } else {
        throw new Error("No boundary found for this city.");
      }
    } catch (error) {
      console.error("Error fetching city boundary:", error.message);
      return null;
    }
  }

  // Get city boundary coordinates
  const getLatLng = async () => {
    toast.loading("Plotting...");
    const data = await getCityBoundary(regionEdit?.name);
    console.log("data", data);
    if (data && data?.coordinates) {
      const coordinates = data?.coordinates[0]?.map((point) => ({
        lat: point[1],
        lng: point[0],
      }));
      //  if (localStorage.getItem("pathInitial")) {
      //    setPathInitial(JSON.parse(localStorage.getItem("pathInitial")));
      setPathInitial(coordinates);
      console.log("coordinates", coordinates);

      //  }

      // Find the center of the polygon
      const centerLat =
        coordinates.reduce((acc, point) => acc + point.lat, 0) /
        coordinates.length;
      const centerLng =
        coordinates.reduce((acc, point) => acc + point.lng, 0) /
        coordinates.length;
      setCenter({ lat: centerLat, lng: centerLng });
      toast.dismiss();
      toast.success("Plotting successful");
    }
  };

  //   useEffect(() => {
  //     getLatLng();
  //   }, []);

  const containerStyle = {
    width: "700px",
    height: "600px",
    margin: "10px 10px",
  };

  const mapUpdateHandler = async () => {
    dispatch(
      setIsUpdating({
        isUpdating: true,
      })
    );
    // Perform region update logic here...
    dispatch(
      setIsUpdating({
        isUpdating: false,
      })
    );
  };

  return (
    <div>
      <div className="flex justify-between px-5 py-2 shadow-md items-center">
        <div className="text-xl text-primary font-semibold">Edit Region</div>
        {isUpdating && (
          <div className="flex space-x-9 items-center">
            <LoadingIcon />
            <div className="italic text-teal-800">Updating...</div>
          </div>
        )}
        <div className="flex space-x-5">
          <div
            onClick={mapUpdateHandler}
            className="bg-secondary hover:bg-gray-300 hover:text-black text-white px-3 py-1 rounded-md cursor-pointer"
          >
            Save
          </div>
          <Link to="/regions">
            <FontAwesomeIcon
              icon={faXmark}
              className="w-5 h-5 mt-1.5 text-primary cursor-pointer"
            />
          </Link>
        </div>
      </div>
      <div className="">
        <div className="flex space-x-1">
          {pathInitial.length && (
            <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
              <GoogleMap
                id="marker-example"
                mapContainerStyle={containerStyle}
                center={center}
                zoom={10}
              >
                <Polygon
                  editable={true}
                  draggable={true}
                  paths={pathInitial}
                  onMouseDown={(e) => {
                    pathInitial.find((latlng) => {
                      latlng.lat === e.latLng.lat() &&
                        latlng.lng === e.latLng.lng() &&
                        setfoundedLatLng(latlng);

                      // setpathInitial(e.latLng);
                    });
                  }}
                  onMouseUp={(e) => {
                    if (!foundedLatLng) {
                      pathCheck.push({
                        lat: e.latLng.lat(),
                        lng: e.latLng.lng(),
                      });
                      setpathCheck(pathCheck);
                    }

                    pathInitial.forEach((latlng) => {
                      if (
                        latlng.lat === foundedLatLng.lat &&
                        latlng.lng === foundedLatLng.lng
                      ) {
                        latlng.lat = e.latLng.lat();
                        latlng.lng = e.latLng.lng();
                      }
                    });
                    setPathInitial(pathInitial);

                    console.log("pathInitial", pathInitial);

                    localStorage.setItem(
                      "pathInitial",
                      JSON.stringify(pathInitial)
                    );

                    // setpathInitial(e.latLng);
                  }}
                  options={{
                    fillColor: "#39121739",
                    fillOpacity: 0.6,
                    strokeColor: "red",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    clickable: true,
                    draggable: false,
                    editable: true,
                  }}
                />
              </GoogleMap>
            </LoadScript>
          )}
          <div className="my-3 shadow-md w-full space-y-5">
            <div className="grid grid-cols-2">
              <div className="mx-2 my-2">
                <div className="flex items-center space-x-3">
                  <div className="text-sm text-gray-600 font-semibold">
                    Enter Region Name
                  </div>
                  <div
                    onClick={getLatLng}
                    className="bg-secondary px-1 py-1 rounded-sm text-white cursor-pointer"
                  >
                    Plot
                  </div>
                </div>
                <input
                  type="text"
                  placeholder="Enter Region Name"
                  className="focus:outline-none border-b-2 border-gray-300 py-1 w-full"
                  onChange={(e) =>
                    setRegionEdit({ ...regionEdit, name: e.target.value })
                  }
                  value={regionEdit?.name}
                />
              </div>
              <div className="mx-2 my-2">
                <div className="text-sm text-gray-600 font-semibold">
                  Distance per hour
                </div>
                <input
                  type="text"
                  placeholder="Enter distance per hour"
                  className="focus:outline-none border-b-2 border-gray-300 w-full py-1"
                  onChange={(e) =>
                    setRegionEdit({
                      ...regionEdit,
                      distance_per_hour: e.target.value,
                    })
                  }
                  value={regionEdit?.distance_per_hour}
                />
              </div>
              {/* Additional fields for Country, City, etc. */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditRegiontow;
